/**
 * Whether this tab is coming back from a redirect sign-in (BUGS #401, fix 3).
 *
 * Reading a redirect result needs Firebase's popup/redirect machinery — a
 * hidden auth iframe (~92KB) plus a project-config request. Asking on EVERY
 * boot put that on every anonymous reader's page. So the boot asks only when a
 * redirect was actually started in this tab.
 *
 * Two signals, either is enough: our own flag, set just before we redirect, and
 * Firebase's own pending-redirect entry (a fallback should the SDK redirect
 * from somewhere we did not mark). If storage cannot be read at all, the answer
 * is "yes": a slower page is recoverable, a lost sign-in is not.
 */
const KEY = 'ia:authRedirectPending';

export function markRedirectPending(): void {
  try {
    window.sessionStorage.setItem(KEY, '1');
  } catch {
    // Storage blocked: `takeRedirectPending` then answers yes by itself.
  }
}

/** True when a redirect may be completing; clears our flag as it reads it. */
export function takeRedirectPending(): boolean {
  try {
    const store = window.sessionStorage;
    const ours = store.getItem(KEY) === '1';
    store.removeItem(KEY);
    const theirs = Object.keys(store).some((k) => k.startsWith('firebase:pendingRedirect'));
    return ours || theirs;
  } catch {
    return true;
  }
}
